import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconAlarmClockOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function _(e, t, r, h, g, l) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([l.iconSizeClass, "d-icon d-icon--alarm-clock-off"]),
    "data-qa": l.dataQA,
    "aria-hidden": l.ariaHidden,
    role: "img",
    "data-name": "Alarm Clock Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M6.001 2A4.5 4.5 0 0 1 10.5 6.499M9.146 1.146a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 0 1-.708.708l-1.5-1.5a.5.5 0 0 1 0-.708Zm-1.15 9.4a4.5 4.5 0 0 1-4.83-.505l-.812.813a.5.5 0 0 1-.708-.708l.813-.812a4.5 4.5 0 0 1 .256-5.911L2 2.707l-.646.647a.5.5 0 1 1-.708-.708l.677-.616-.677-.676a.5.5 0 1 1 .708-.708l10 10a.5.5 0 0 1-.708.708l-1.569-1.57a4.5 4.5 0 0 1-1.081.762ZM2.479 6.355a3.5 3.5 0 0 1 .944-2.225L8.37 9.077a3.5 3.5 0 0 1-5.89-2.722Z" }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, f);
}
const C = /* @__PURE__ */ u(c, [["render", _]]);
export {
  C as default
};
//# sourceMappingURL=alarm-clock-off.js.map
